import { connect } from "react-redux";

import _Modal from "./studio_modal.jsx";
import _ModalInput from "./studio_modal_input.jsx";
import _ModalHeader from "./studio_modal_header.jsx";
import _ModalBody from "./studio_modal_body.jsx";
import _ModalFooter from "./studio_modal_footer.jsx";
import _ModalFooterSpinner from "./studio_modal_footer_spinner.jsx";
import _ModalButton from "./studio_modal_action_button.jsx";
import _ModalIconLink from "./studio_modal_icon_link.jsx";

export * from "./studio_modal_input.jsx";

export const Modal = _Modal;
export const ModalInput = _ModalInput;
export const ModalHeader = _ModalHeader;
export const ModalBody = _ModalBody;
export const ModalFooter = _ModalFooter;
export const ModalFooterSpinner = _ModalFooterSpinner;
export const ModalButton = _ModalButton;
export const ModalIconLink = _ModalIconLink;

export const modalConnect = (component) => {
  const mapStateToProps = (state) => (state.modal ? state.modal.state : {});

  return connect(mapStateToProps)(component);
};
